const blackAndRedRuleset = [
    { name: "1 Schluck 🔴", idea: "Nimm 1 Schluck", freq: 3, bg: "#ff0000", text: "#222" },
    { name: "Gib 1 Schluck 🖤", idea: "Gib 1 Schluck weiter", freq: 3, bg: "#000000", text: "#fff" },
    { name: "2 Schlucke 🔴", idea: "Nimm 2 Schlucke", freq: 3, bg: "#ff0000", text: "#222" },
    { name: "Gib 2 Schlucke 🖤", idea: "Gib 2 Schlucke weiter", freq: 3, bg: "#000000", text: "#fff" },
    { name: "3 Schlucke 🔴", idea: "Nimm 3 Schlucke", freq: 3, bg: "#ff0000", text: "#222" },
    { name: "Gib 3 Schlucke 🖤", idea: "Gib 3 Schlucke weiter", freq: 3, bg: "#000000", text: "#fff" },
    { name: "Shot nehmen 🔴", idea: "Nimm einen Shot", freq: 2, bg: "#ff0000", text: "#222" },
    { name: "Shot geben 🖤", idea: "Gib einen Shot weiter", freq: 2, bg: "#000000", text: "#fff" },
    { name: "LOOOSER 🥃", idea: "Exe dein ganze Glas", freq: 1, bg: "#8B0000", text: "#fff" },
    { name: "JACKPOT 🎱", idea: "Lass jemand anderen das ganze Glas exen", freq: 1, bg: "#000000", text: "#fff" },
];

export default blackAndRedRuleset;
